export enum WizardMessageNames {
  NAVIGATE_TO_NEXT_STEP = 'NAVIGATE_TO_NEXT_STEP',
  NAVIGATE_TO_PREVIOUS_STEP = 'NAVIGATE_TO_PREVIOUS_STEP',
  SHOW_PAGE_LOADER = 'SHOW_PAGE_LOADER',
  HIDE_PAGE_LOADER = 'HIDE_PAGE_LOADER',
}
